<template>
  <div style="clear:both;" v-if="allApprovals.length > 0">
    <v-card :class="bgColor">
      <v-toolbar elevation="8" density="compact">
        <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <csv-export :data="sortedApprovals" :exportConfig="exportConfig"></csv-export>
      </v-toolbar>
      <v-form ref="approvalForm" autocomplete="off">
        <v-container fluid>
          
          <!-- warning dragons sleep here. the below template is for pass 0 only, it is almost replicated in the v-else -->
          <template v-if="showNoPanels">
            <v-row>
              <v-col cols="12">
                <v-card>
                  <template v-if="currentApproval[0] && showMyApproval">
                    <v-toolbar elevation="8" density="compact">
                      <v-toolbar-title>{{ $t('My_Approval') }} ({{ currentApproval[0].user.displayName }})</v-toolbar-title>
                    </v-toolbar>
                    <v-container fluid>
                      <template v-if="!readonly">
                        <v-row dense justify="start">
                          <v-col cols="12" md="12">
                            <v-dialog v-model="approvalCommentDialog" persistent max-width="600px">
                              <template v-slot:activator="{ props: activatorProps }">
                                <v-btn
                                  color="success"
                                  v-bind="activatorProps"
                                  @click="
                                    previousUserApproval.decision = currentApproval[0].decision;
                                    previousUserApproval.comment = currentApproval[0].comment;
                                    previousUserApproval.modifiedByDate = currentApproval[0].modifiedByDate;
                                    currentApproval[0].decision = {
                                      key: approvedKey,
                                      value: approvedValue
                                    };
                                    currentApproval[0].comment = '';
                                    currentApproval[0].modifiedByDate = null
                                  "
                                  class="mx-2 mt-3"
                                  :disabled="currentApproval[0].decision.key == approvedKey"
                                  >{{ $t('Approve') }}</v-btn
                                >
                                <v-btn
                                  color="error"
                                  v-bind="activatorProps"
                                  @click="
                                    previousUserApproval.decision = currentApproval[0].decision;
                                    previousUserApproval.comment = currentApproval[0].comment;
                                    previousUserApproval.modifiedByDate = currentApproval[0].modifiedByDate;
                                    currentApproval[0].decision = {
                                      key: rejectedKey,
                                      value: rejectedValue
                                    };
                                    currentApproval[0].comment = '';
                                    currentApproval[0].modifiedByDate = null
                                  "
                                  class="mx-2 mt-3"
                                  :disabled="currentApproval[0].decision.key == rejectedKey"
                                  >{{ $t('Reject') }}</v-btn
                                >
                              </template>

                              <v-card>
                                <v-card-title>
                                  <span class="text-h6 font-weight-bold">{{ $t('Comment') }}</span>
                                </v-card-title>
                                <v-card-text>
                                  <v-container>
                                    <v-row dense>
                                      <v-col cols="12">
                                        <v-form ref="approvalCommentMo" v-model="valid" autocomplete="off">
                                          <v-textarea
                                            v-model="currentApproval[0].comment"
                                            name="approvalComment"
                                            variant="underlined"
                                            :rules="isRejected ? rejectedCommentRules : approvedCommentRules"
                                            auto-grow
                                          ></v-textarea>
                                        </v-form>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn                                    
                                    variant="text"
                                    elevation="0"     
                                    class="text-button"                              
                                    @click="
                                      currentApproval[0].decision = previousUserApproval.decision;
                                      currentApproval[0].comment = previousUserApproval.comment;
                                      currentApproval[0].modifiedByDate = previousUserApproval.modifiedByDate;
                                      approvalCommentDialog = false
                                    "
                                    >{{ $t('Cancel') }}</v-btn
                                  >
                                  <v-btn                                    
                                    variant="text"
                                    elevation="0"
                                    class="text-button"
                                    :disabled="!valid"
                                    @click="
                                      approvalCommentDialog = false;
                                      submit()
                                    "
                                    >{{ $t('Save') }}</v-btn
                                  >
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-col>
                        </v-row>
                      </template>
                    </v-container>
                  </template>
                  <!-- /user input -->
                  <!-- display only with history -->
                  <template v-if="true">
                    <v-row>
                      <v-col cols="12">
                        <v-container fluid>
                          <v-data-table
                            :headers="approvalHeaders"
                            :items="groupedByPassApprovals[0]"
                            class="elevation-1"
                            disable-pagination
                            dense
                            density="compact"
                            hide-default-footer
                            :loading="isLoadingApprovals"
                            must-sort
                            :sort-by="[{ key: 'decisionDate', order: 'asc' }]"
                            :sort-desc="[false, false]"
                            :expanded.sync="expanded"
                            show-expand
                            :items-per-page="-1"
                          >
                            <template v-slot:expanded-row="{ headers, item }" v-if="showHistory">
                              <tr
                                v-for="(historyItem, index) in item.history"
                                :key="`${item.id}_${index}`"
                                class="approvalHistory"
                              >
                                <td class="userCell text-right">
                                  <template v-if="historyItem.mocStatus && historyItem.mocStatus.length">
                                    <span v-for="(mocStatus, i) in historyItem.mocStatus" :key="i">
                                      <v-tooltip v-if="showMocStatusHistory(index, mocStatus, item.history)" bottom>
                                        <template v-slot:activator="{ props }">
                                          <v-icon
                                            :color="
                                              pendingOwnerDecisionStatus.value === mocStatus.status.value ? 'blue' : 'accent'
                                            "
                                            v-bind="props"
                                            >{{
                                              pendingOwnerDecisionStatus.value === mocStatus.status.value
                                                ? 'mdi-information-outline'
                                                : 'mdi-backup-restore'
                                            }}</v-icon
                                          >
                                        </template>
                                        <span>{{ mocStatus.status.name }} - {{ $filters.DateTimeFilter(mocStatus.date) }}</span>
                                      </v-tooltip>
                                    </span>
                                  </template>
                                  {{ $t('Approval_Response') }} #{{ item.history.length - index }}
                                </td>
                                <td class="decisionCell" v-if="historyItem.decision.key">
                                  {{ decisionValue(historyItem.decision.key) }}
                                </td>
                                <td class="decisionCell" v-else>{{ $t('No_Response') }}</td>
                                <!-- <td class="multipassCell">{{ historyItem.decisionPass }}</td> -->
                                <td class="commentCell" v-if="historyItem.decision.key && historyItem.comment">
                                  <pre style="white-space: pre-wrap;">{{ historyItem.comment }}</pre>
                                </td>
                                <td class="commentCell" v-else>&nbsp;</td>

                                <td class="dateCell" v-if="historyItem.decision.key">
                                  {{ $filters.DateTimeFilter(historyItem.decisionDate) }}
                                </td>
                                <td class="dateCell" v-else>&nbsp;</td>
                              </tr>
                            </template>
                            <template v-slot:item="{ item, internalItem, isExpanded, toggleExpand }">
                              <tr
                                @click="
                                  toggleExpand(internalItem)
                                "
                                :title="
                                  showHistory && item.history && item.history.length
                                    ? expanded.findIndex(e => e.id === item.id) > -1
                                      ? $t('Click_To_Hide_History')
                                      : $t('Click_To_See_History')
                                    : ''
                                "
                              >
                                <td class="userCell">
                                  {{ item.user.displayName }}
                                  <v-icon v-if="item.history && item.history.length && showHistory">{{
                                    expanded.findIndex(e => e.id === item.id) > -1 ? 'mdi-chevron-up' : 'mdi-chevron-down'
                                  }}</v-icon>
                                </td>
                                <td class="decisionCell" v-if="item.decision.key == null">
                                  <span v-if="displayCurrentNoResponseText">{{ $t('No_Response') }}</span>
                                </td>
                                <td
                                  class="decisionCell"
                                  v-if="item.decision.key != null"
                                  :class="getDecisionClass(item.decision.key)"
                                >
                                  {{ decisionValue(item.decision.key) }}
                                </td>
                                <!-- <td class="multipassCell">{{ props.item.decisionPass }}</td> -->
                                <td class="commentCell" v-if="item.decision.key == null || item.comment == ''">
                                  &nbsp;
                                </td>
                                <td class="commentCell" v-if="item.decision.key && item.comment">
                                  <pre style="white-space: pre-wrap;">{{ item.comment }}</pre>
                                </td>
                                <td class="dateCell" v-if="item.decision.key == null">&nbsp;</td>
                                <td class="dateCell" v-if="item.decision.key">
                                  {{ $filters.DateTimeFilter(item.decisionDate) }}
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-container>
                      </v-col>
                    </v-row>
                  </template>
                </v-card>
                <!-- </template> -->
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row>
              <v-expansion-panels class="mx-3 mb-2" v-model="panel" multiple>
                <v-expansion-panel v-for="(pass, index) in groupedByPassApprovals" :key="index">
                  <v-expansion-panel-title
                    :key="index"
                    disable-icon-rotate
                    @click="show[index] = !show[index]"
                    :color="isActivePass(index) ? 'activePeoplePicker' : 'disabledPeoplePicker'"
                    >{{ getPassLabel(index) }}<v-spacer></v-spacer> {{ getPassApprovalDisplay(pass) }}
                    <template v-slot:actions>
                      <v-icon class="ml-2">{{ show[index] ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                    </template>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text :color="backgroundColor(index)">
                    <v-row>
                      <v-col cols="12">
                        <v-card>
                          <template
                            v-if="
                              currentApproval[0] &&
                                showMyApproval &&
                                (currentApproval[0].decisionPass === moc.multiPassCurrentPass &&
                                  pass[0].user.decisionPass === moc.multiPassCurrentPass)
                            "
                          >
                            <v-toolbar dense>
                              <v-toolbar-title
                                >{{ $t('My_Approval') }} ({{ currentApproval[0].user.displayName }})</v-toolbar-title
                              >
                            </v-toolbar>
                            <v-container fluid>
                              <template v-if="!readonly">
                                <v-row dense justify="start">
                                  <v-col cols="12" md="12">
                                    <v-dialog v-model="approvalCommentDialog" persistent max-width="600px">
                                      <template #activator="{ on }">
                                        <v-btn
                                          color="success"
                                          v-on="on"
                                          @click="
                                            previousUserApproval.decision = currentApproval[0].decision;
                                            previousUserApproval.comment = currentApproval[0].comment;
                                            previousUserApproval.modifiedByDate = currentApproval[0].modifiedByDate;
                                            currentApproval[0].decision = {
                                              key: approvedKey,
                                              value: approvedValue
                                            };
                                            currentApproval[0].comment = '';
                                            currentApproval[0].modifiedByDate = null
                                          "
                                          class="mx-2 mt-3"
                                          :disabled="currentApproval[0].decision.key == approvedKey"
                                          >{{ $t('Approve') }}</v-btn
                                        >
                                        <v-btn
                                          color="error"
                                          v-on="on"
                                          @click="
                                            previousUserApproval.decision = currentApproval[0].decision;
                                            previousUserApproval.comment = currentApproval[0].comment;
                                            previousUserApproval.modifiedByDate = currentApproval[0].modifiedByDate;
                                            currentApproval[0].decision = {
                                              key: rejectedKey,
                                              value: rejectedValue
                                            };
                                            currentApproval[0].comment = '';
                                            currentApproval[0].modifiedByDate = null
                                          "
                                          class="mx-2 mt-3"
                                          :disabled="currentApproval[0].decision.key == rejectedKey"
                                          >{{ $t('Reject') }}</v-btn
                                        >
                                      </template>

                                      <v-card>
                                        <v-card-title>
                                          <span class="text-h6 font-weight-bold">{{ $t('Comment') }}</span>
                                        </v-card-title>
                                        <v-card-text>
                                          <v-container>
                                            <v-row dense>
                                              <v-col cols="12">
                                                <v-form ref="approvalCommentMo" v-model="valid" autocomplete="off">
                                                  <v-textarea
                                                    v-model="currentApproval[0].comment"
                                                    name="approvalComment"
                                                    :rules="isRejected ? rejectedCommentRules : approvedCommentRules"
                                                    auto-grow
                                                  ></v-textarea>
                                                </v-form>
                                              </v-col>
                                            </v-row>
                                          </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                          <v-spacer></v-spacer>
                                          <v-btn                                            
                                            variant="text"
                                            elevation="0"
                                            class="text-button"
                                            @click="
                                              currentApproval[0].decision = previousUserApproval.decision;
                                              currentApproval[0].comment = previousUserApproval.comment;
                                              currentApproval[0].modifiedByDate = previousUserApproval.modifiedByDate;
                                              approvalCommentDialog = false
                                            "
                                            >{{ $t('Cancel') }}</v-btn
                                          >
                                          <v-btn                                            
                                            variant="text"
                                            elevation="0"
                                            class="text-button"
                                            :disabled="!valid"
                                            @click="
                                              approvalCommentDialog = false;
                                              submit()
                                            "
                                            >{{ $t('Save') }}</v-btn
                                          >
                                        </v-card-actions>
                                      </v-card>
                                    </v-dialog>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-container>
                          </template>
                          <!-- /user input -->

                          <!-- display only with history -->
                          <template v-if="true">
                            <v-container fluid>
                              <v-row>
                                <v-col cols="12">
                                  <v-data-table
                                    :headers="approvalHeaders"
                                    :items="pass"
                                    class="elevation-1"
                                    disable-pagination
                                    dense
                                    hide-default-footer
                                    :loading="isLoadingApprovals"
                                    must-sort
                                    :sort-by="[{ key: 'decisionDate', order: 'asc' }]"
                                    :sort-desc="[false]"
                                    :expanded.sync="expanded[index]"
                                    show-expand
                                    :items-per-page="-1"
                                  >
                                    <template v-slot:expanded-row="{ headers, item }" v-if="showHistory">
                                      <tr
                                        v-for="(historyItem, hIndex) in item.history"
                                        :key="`${item.id}_${hIndex}`"
                                        class="approvalHistory"
                                      >
                                        <td class="userCell text-right">
                                          <template v-if="historyItem.mocStatus && historyItem.mocStatus.length">
                                            <span v-for="(mocStatus, i) in historyItem.mocStatus" :key="i">
                                              <v-tooltip v-if="showMocStatusHistory(index, mocStatus, item.history)" bottom>
                                                <template v-slot:activator="{ props }">
                                                  <v-icon
                                                    :color="
                                                      pendingOwnerDecisionStatus.value === mocStatus.status.value
                                                        ? 'blue'
                                                        : 'accent'
                                                    "
                                                    v-bind="props"
                                                    >{{
                                                      pendingOwnerDecisionStatus.value === mocStatus.status.value
                                                        ? 'mdi-information-outline'
                                                        : 'mdi-backup-restore'
                                                    }}</v-icon
                                                  >
                                                </template>
                                                <span>{{ mocStatus.status.name }} - {{ $filters.DateTimeFilter(mocStatus.date) }}</span>
                                              </v-tooltip>
                                            </span>
                                          </template>
                                          {{ $t('Approval_Response') }} #{{ item.history.length - hIndex }}
                                        </td>
                                        <td class="decisionCell" v-if="historyItem.decision.key">
                                          {{ decisionValue(historyItem.decision.key) }}
                                        </td>
                                        <td class="decisionCell" v-else>{{ $t('No_Response') }}</td>
                                        <td class="commentCell" v-if="historyItem.decision.key && historyItem.comment">
                                          <pre style="white-space: pre-wrap;">{{ historyItem.comment }}</pre>
                                        </td>
                                        <td class="commentCell" v-else>&nbsp;</td>

                                        <td class="dateCell" v-if="historyItem.decision.key">
                                          {{ $filters.DateTimeFilter(historyItem.decisionDate) }}
                                        </td>
                                        <td class="dateCell" v-else>&nbsp;</td>
                                      </tr>
                                    </template>
                                    <template v-slot:item="{ item, internalItem, isExpanded, toggleExpand }">
                                      <tr
                                        @click="
                                          toggleExpand(internalItem)
                                        "
                                        :title="
                                          showHistory && item.history && item.history.length
                                            ? showPassApprovalHistory[(index, item.user.id)]
                                              ? $t('Click_To_Hide_History')
                                              : $t('Click_To_See_History')
                                            : ''
                                        "
                                      >
                                        <td class="userCell">
                                          {{ item.user.displayName }}
                                          <v-icon v-if="item.history && item.history.length && showHistory">{{
                                            showPassApprovalHistory[(index, item.user.id)] ? 'mdi-chevron-up' : 'mdi-chevron-down'
                                          }}</v-icon>
                                        </td>
                                        <td class="decisionCell" v-if="item.decision.key == null">
                                          <span v-if="displayCurrentNoResponseText">{{ $t('No_Response') }}</span>
                                        </td>
                                        <td
                                          class="decisionCell"
                                          v-if="item.decision.key != null"
                                          :class="getDecisionClass(item.decision.key)"
                                        >
                                          {{ decisionValue(item.decision.key) }}
                                        </td>
                                        <td
                                          class="commentCell"
                                          v-if="item.decision.key == null || item.comment == ''"
                                        >
                                          &nbsp;
                                        </td>
                                        <td class="commentCell" v-if="item.decision.key && item.comment">
                                          <pre style="white-space: pre-wrap;">{{ item.comment }}</pre>
                                        </td>
                                        <td class="dateCell" v-if="item.decision.key == null">&nbsp;</td>
                                        <td class="dateCell" v-if="item.decision.key">
                                          {{ $filters.DateTimeFilter(item.decisionDate) }}
                                        </td>
                                      </tr>
                                    </template>
                                  </v-data-table>
                                </v-col>
                              </v-row>
                            </v-container>
                          </template>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </template>
        </v-container>
      </v-form>
    </v-card>
    <toaster ref="toaster"></toaster>
    <loading-dialog ref="loadingDialog"></loading-dialog>
  </div>
</template>

<script>
import { FormStatus } from '@/common'
import { mapState } from 'vuex'
import ApprovalService from '@/services/approval.service'
import { multiPropertySortWithNullConcat } from '@/common/arrayFunctions'
import Toaster from '@/components/Toaster'
import LoadingDialog from '@/components/mocForm/LoadingDialog'
import CsvExport from '@/components/CsvExport'
import { DecisionTypes } from '@/common/types'
import { Flags } from '@/common/flags'

export default {
  name: 'Approvals',
  data() {
    return {
      approvals: [],
      allApprovals: [],
      loadingApprovals: true,
      approved: false,
      rejected: false,
      showVCard: false,
      comment: '',
      currentUserApproval: {
        comment: '',
        decision: ''
      },
      previousUserApproval: {
        comment: '',
        decision: '',
        modifiedByDate: null
      },
      ogModifiedDate: null,
      isSaving: false,
      showCurrentUserComment: false,
      minimumLength: 3,      
      valid: false,
      approvalCommentDialog: false,
      approvalHeaders: [
        {
          title: this.$t('Approver'),
          key: 'user.displayName',
          width: '300px',
          sortable: true
        },
        {
          title: this.$t('Decision'),
          key: 'decision.key'
        },
        {
          title: this.$t('Comment'),
          key: 'comment'
        },
        {
          title: this.$t('Date'),
          key: 'decisionDate'
        }
      ],
      exportConfig: {
        [this.$t('Approver')]: 'user.mail',
        [this.$t('Decision')]: 'decision.value',
        [this.$t('Comment')]: 'comment',
        [this.$t('Date')]: {
          property: 'decisionDate',
          isDate: true
        }
      },
      expanded: [],
      show: new Array(this.moc.multiPassCurrentPass).fill(false),
      activePanel: 0,
      panel: [this.moc.multiPassCurrentPass],
      showPassApprovalHistory: [new Array(this.moc.multiPassCurrentPass).fill(0), false]
    }
  },
  props: {
    setApprovals: {
      type: Function
    },
    showHistory: {
      type: Boolean,
      default: false
    },
    moc: {
      type: Object
    },
    bgColor: {
      type: String
    },
    showPreLoadedApprovals: {
      type: Boolean,
      default: false
    },
    preLoadedApprovals: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Toaster,
    CsvExport,
    LoadingDialog
  },
  methods: {
    backgroundColor: function(i) {
      return parseInt(i, 10) === this.moc.multiPassCurrentPass ? 'backgroundNormal' : 'backgroundReadOnly'
    },
    getApprovals: function(mocId) {
      if (mocId !== null) {
        return new Promise((resolve, reject) => {
          this.loadingApprovals = true
          ApprovalService.getAllApprovals(mocId)
            .then(data => {
              if (this.setApprovals) this.setApprovals(data)
              if (data.length > 0) {
                resolve(data)
              } else {
                resolve([])
              }
              this.loadingApprovals = false
            })
            .catch(e => {
              console.error(this.$t('Error_GetMOCApprovals', { mocId: mocId }), e)
              reject(e)
              this.loadingApprovals = false
            })
        })
      }
    },
    getPassApprovalDisplay: function(pass) {
      let temp = pass
      let approveCount = temp.filter(p => {
        return p.decision.key === DecisionTypes.properties[DecisionTypes.APPROVED].key
      })
      let rejectedCount = temp.filter(p => {
        return p.decision.key === DecisionTypes.properties[DecisionTypes.REJECTED].key
      })
      let noResponseCount = temp.filter(p => {
        return !p.decision.key
      })

      return ` ${this.$t('Approved')} (${approveCount.length}) 
          ${this.$t('Rejected')} (${rejectedCount.length}) 
          ${this.$t('No_Response')} (${noResponseCount.length})`
    },
    getPassLabel: function(passNumber) {
      if (passNumber - 1 < 0) {
        return this.$t('Original_Pass')
      }
      return this.moc.approvalProcessType.multiPass.approvalPasses[passNumber - 1].label
    },
    isActivePass: function(i) {
      return parseInt(i, 10) === this.moc.multiPassCurrentPass ? true : false
    },
    decisionValue: function(key) {
      return DecisionTypes.properties[DecisionTypes[key.toUpperCase()]].value
    },
    submit: function() {
      if (!this.isSaving) {
        this.isSaving = true
        this.$refs.loadingDialog.show()
        if (this.currentUserApproval[0].modifiedByDate === null) {
          this.currentUserApproval[0].modifiedByDate = this.ogModifiedDate
        }
        const data = this.currentUserApproval[0]
        if (!data.comment || data.comment.trim() === '') {
          data.comment = this.$t('No_Comment_Provided')
        }

        ApprovalService.save(data)
          .then(result => {
            if (result.success) {
              this.$refs.loadingDialog.hide({ redirect: true, message: result.message })
            } else {
              throw new Error(result.message)
            }
          })
          .catch(e => {
            this.currentApproval[0].decision = this.previousUserApproval.decision
            this.currentApproval[0].comment = this.previousUserApproval.comment
            this.currentApproval[0].modifiedByDate = this.previousUserApproval.modifiedByDate
            this.$refs.loadingDialog.error({
              metadata: 'submitApproval',
              error: e,
              message: this.$t('Error_SettingDecision')
            })
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    },
    getDecisionClass(decision) {
      return decision === DecisionTypes.properties[DecisionTypes.APPROVED].key
        ? DecisionTypes.properties[DecisionTypes.APPROVED].key
        : DecisionTypes.properties[DecisionTypes.REJECTED].key
    },
    getMocHistoryEquivalent(approvalHistoryRow) {
      const result = this.mocHistoryWithApprovals.filter(h => {
        const approvalRowDate = new Date(approvalHistoryRow.modifiedByDate).getTime()
        const mocHistoryDate = new Date(h.date).getTime()
        return approvalRowDate <= mocHistoryDate
      })

      const historyClosestToApprovalRow = this.$_.orderBy(result, ['date'], ['asc'])[0]
      return historyClosestToApprovalRow
    },
    getMocHistoryPendingOwnerDecisionEquivalent(approvalHistoryRow) {
      const result = this.mocHistoryPastPendingOwnerDecision.filter(h => {
        const approvalRowDate = new Date(approvalHistoryRow.modifiedByDate).getTime()
        const mocHistoryDate = new Date(h.date).getTime()
        return approvalRowDate <= mocHistoryDate
      })

      const historyClosestToApprovalRow = this.$_.orderBy(result, ['date'], ['asc'])[0]
      return historyClosestToApprovalRow
    },
    processApprovals(data, currentUser) {
      this.allApprovals = this.$_.slice(data, 0)
      const currentPassApprovals = data.filter(a => a.decisionPass === this.moc.multiPassCurrentPass)
      const index = this.$_.findIndex(currentPassApprovals, function(o) {
        return o.user.id === currentUser.id
      })
      if (index >= 0) {
        this.currentUserApproval = this.$_.pullAt(currentPassApprovals, [index])
        this.previousUserApproval.decision = this.currentUserApproval[0].decision
        if (this.currentUserApproval[0].decision.key === null) {
          this.ogModifiedDate = this.currentUserApproval[0].modifiedByDate
          this.previousUserApproval.comment = null
          this.previousUserApproval.modifiedByDate = null
          this.currentUserApproval[0].modifiedByDate = null
        } else {
          this.previousUserApproval.comment = this.currentUserApproval[0].comment
          this.previousUserApproval.modifiedByDate = this.currentUserApproval[0].modifiedByDate
          this.ogModifiedDate = this.currentUserApproval[0].modifiedByDate
        }
      }
    },
    showMocStatusHistory(index, currentMocStatus, history) {
      const siblingIndex = index - 1
      if (history[siblingIndex]) {
        const mocStatusInSibling = history[siblingIndex].mocStatus.find(m => m.status.value === currentMocStatus.status.value)
        return (mocStatusInSibling || {}).date !== (currentMocStatus || {}).date
      }
      return true
    }
  },
  computed: {
    ...mapState('currentUser', ['user']),
    showNoPanels() {
      return this.moc.multiPassCurrentPass === 0
    },
    mocHistoryWithApprovals() {
      return this.moc.history.filter(history => history.approvals)
    },
    mocHistoryPastPendingOwnerDecision() {
      return this.moc.history.filter((history, index) => {
        const nextHistoryItem = this.moc.history[index + 1]

        const isFromMultipass =
          nextHistoryItem &&
          ((nextHistoryItem.flags || []).includes(Flags.properties[Flags.MULTIPASS].key) &&
            (nextHistoryItem.status.value === FormStatus.properties[FormStatus.SUBMITTED].value ||
              nextHistoryItem.status.value === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value))
        const isFromNormalFlow =
          nextHistoryItem &&
          (nextHistoryItem.status.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value ||
            nextHistoryItem.status.value ===
              FormStatus.properties[FormStatus.CHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value ||
            nextHistoryItem.status.value === FormStatus.properties[FormStatus.CHANGEISFULLYIMPLEMENTED].value ||
            nextHistoryItem.status.value === FormStatus.properties[FormStatus.OWNERAPPROVEDDEFERREDSTARTDATE].value)
        return (
          history.status.value === FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value &&
          (isFromMultipass || isFromNormalFlow)
        )
      })
    },
    approvedKey() {
      return DecisionTypes.properties[DecisionTypes.APPROVED].key
    },
    approvedValue() {
      return DecisionTypes.properties[DecisionTypes.APPROVED].value
    },
    rejectedKey() {
      return DecisionTypes.properties[DecisionTypes.REJECTED].key
    },
    rejectedValue() {
      return DecisionTypes.properties[DecisionTypes.REJECTED].value
    },
    rejectedCommentRules: {
      get: function() {
        return [
          v => !!v || this.$t('Rule_Required_Comment'),
          v => (v && v.trim().length > this.minimumLength) || this.$t('Rule_MinimumLength', { length: this.minimumLength })
          
        ]
      }
    },
    approvedCommentRules: {
      get: function() {
        return [v => v.trim().length >= 0 || '']
      }
    },
    noRules: {
      get: function() {
        return [v => v.trim().length >= 0 || '']
      }
    },
    isLoadingApprovals: function() {
      return this.loadingApprovals
    },
    isRejected: function() {
      return (this.currentApproval[0] || {}).decision.key === DecisionTypes.properties[DecisionTypes.REJECTED].key
    },
    communityAbbreviation: function() {
      return this.moc.mocId.substr(0, 3)
    },
    previewComment: function() {
      return this.comment
    },
    currentApproval: function() {
      return this.currentUserApproval
    },
    hasDecision: function() {
      return this.currentUserApproval.decision.key !== null
    },
    hasComment: function() {
      return this.currentUserApproval.comment !== null
    },
    hasModifiedByDate: function() {
      return this.currentUserApproval.modifiedByDate !== null
    },
    pendingOwnerDecisionStatus() {
      return FormStatus.properties[FormStatus.PENDINGOWNERDECISION]
    },
    readonly: function() {
      if (this.showPreLoadedApprovals) {
        return true
      }
      switch (this.moc.status.value) {
        case FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value:
        case FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value: {
          return false
        }

        default:
          return true
      }
    },
    showMyApproval: function() {
      switch (this.moc.status.value) {
        case FormStatus.properties[FormStatus.BEINGREVISED].value:
        case FormStatus.properties[FormStatus.OWNERAPPROVEDDEFERREDSTARTDATE].value:
        case FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value:
        case FormStatus.properties[FormStatus.CHANGEISFULLYIMPLEMENTED].value:
        case FormStatus.properties[FormStatus.CLOSED].value:
        case FormStatus.properties[FormStatus.CLOSEDREJECTED].value:
        case FormStatus.properties[FormStatus.CLOSEDVOIDED].value:
        case FormStatus.properties[FormStatus.SUBMITTED].value:
        case FormStatus.properties[FormStatus.CHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value:
          return false
        default:
          return true
      }
    },
    displayCurrentNoResponseText: function() {
      return (
        this.showMyApproval ||
        (this.moc.status.value === FormStatus.properties[FormStatus.CHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value ||
          this.moc.status.value === FormStatus.properties[FormStatus.CHANGEISFULLYIMPLEMENTED].value ||
          this.moc.status.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value ||
          this.moc.status.value === FormStatus.properties[FormStatus.CLOSED].value ||
          this.moc.status.value === FormStatus.properties[FormStatus.CLOSEDREJECTED].value ||
          this.moc.status.value === FormStatus.properties[FormStatus.OWNERAPPROVEDDEFERREDSTARTDATE].value ||
          this.moc.status.value === FormStatus.properties[FormStatus.CLOSEDVOIDED].value)
      )
    },
    groupedByPassApprovals: function() {
      //first lets filter out all approvals that are not for the current pass(es)
      let currentPassesApprovals = this.sortedApprovals.filter(a => {
        return a.decisionPass <= this.moc.multiPassCurrentPass
      })
      let grouped = currentPassesApprovals.reduce((acc, item) => {
        ;(acc[item['decisionPass']] = acc[item['decisionPass']] || []).push(item)
        return acc
      }, {})

      return grouped
    },
    sortedApprovals: function() {
      let approvals = this.allApprovals
      let sortBy = [
        { prop: 'modifiedByDate', direction: 1 },
        {
          prop: 'decision',
          direction: 1
        }
      ]
      const sorted = multiPropertySortWithNullConcat(sortBy, approvals, 'decision')
      const result = sorted.map(a => {
        if (!a.history) return a
        const reversedHistory = a.history
          .map(h => {
            let historyPendingOwnerDecision = undefined
            if (!h.decision.key) {
              historyPendingOwnerDecision = this.getMocHistoryPendingOwnerDecisionEquivalent(h)
            }
            return {
              ...h,
              mocStatus: [historyPendingOwnerDecision].filter(r => r)
            }
          })
          .reverse()
        return {
          ...a,
          history: reversedHistory
        }
      })
      return result
    },
    totalApprovedCount: function() {
      const temp = this.allApprovals
      let count = temp.filter(o => {
        return o.decisionPass === 0 && o.decision.key === DecisionTypes.properties[DecisionTypes.APPROVED].key
      })

      return count.length
    },
    totalRejectedCount: function() {
      const temp = this.allApprovals
      let count = temp.filter(o => {
        return o.decisionPass === 0 && o.decision.key === DecisionTypes.properties[DecisionTypes.REJECTED].key
      })

      return count.length
    },
    totalNoResponseCount: function() {
      const temp = this.allApprovals
      let count = temp.filter(o => {
        return o.decisionPass === 0 && !o.decision.key
      })

      return count.length
    },
    toolbarTitle: function() {
      if (this.moc.multiPassCurrentPass > 0) {
        return `${this.$t('Approvals')}`
      }

      return `${this.$t('Approvals')} --
          ${this.$t('Approved')} (${this.totalApprovedCount}) 
          ${this.$t('Rejected')} (${this.totalRejectedCount}) 
          ${this.$t('No_Response')} (${this.totalNoResponseCount})`
    }
  },
  created() {
    if (this.showPreLoadedApprovals) {
      this.allApprovals = this.$_.slice(this.preLoadedApprovals, 0)
      this.loadingApprovals = false
    } else {
      const currentUser = this.$store.state.currentUser.user

      if (this.moc.mocId != null) {
        this.getApprovals(this.moc.mocId).then(data => {
          this.processApprovals(data, currentUser)
        })
      }

      this.show[this.moc.multiPassCurrentPass] = true
    }
  }
}
</script>

<style scoped>
.approved {
  color: green;
}
.rejected {
  color: #d50000;
}
pre {
  font-family: 'Roboto mono', monospace;
}
.approvalHistory {
  background-color: rgb(236, 236, 241);
}
.approvalHistory .userCell {
  background-color: white !important;
}

.userCell {
  vertical-align: top;
  min-width: 300px;
  max-width: 300px;
}
.decisionCell {
  vertical-align: top;
  min-width: 150px;
  max-width: 150px;
}
.multipassCell {
  vertical-align: top;
  min-width: 150px;
  max-width: 150px;
}
.dateCell {
  vertical-align: top;
  min-width: 200px;
  max-width: 200px;
}
.commentCell {
  vertical-align: top;
  width: 100%;
}
.theme--dark .approvalHistory {
  background-color: rgb(54, 54, 56);
}
.text-button { 
   background-color: transparent !important;   
  }
</style>
